import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { getRequestUserSessionData as getUserData, trueFalseToBoolean } from '../../../../../utils/helpers.utils';
import { actions } from 'react-redux-form';
import {
    //model
    wirelineOtherRequestModel
    //action
    , resetWirelineOtherRequestForm
    , setOtherRequestOptions
    , setSubscriptionDetails
    , setFormSubmitted
} from './../../../../../constants/model-reducers/external/request/wireline-request/wireline-other-request.settings';

export const otherRequestModelAInitialState = wirelineOtherRequestModel;

const defaultState = () => ({
    otherOptions: []
    , subscription: {}
    , formSubmitted: false
});

const initialState = defaultState();


export const wirelineOtherRequestActions = {
    onSubscriptionSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineOtherRequestFormA } = state().form;

        if (value === '') {
            resetForm(dispatch);
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
            var obj = objects.find(o => o[propsName] === value);
            if (obj != null && obj.CircuitId != wirelineOtherRequestFormA.circuitId) {
                resetForm(dispatch);
                dispatch(actions.change('wirelineOtherRequestFormA.circuitCode', value));
                dispatch(actions.change('wirelineOtherRequestFormA.circuitId', obj.CircuitId));
                dispatch(actions.change('wirelineOtherRequestFormA.vendorDetailId', obj.VendorDetailId));
                dispatch({ type: setSubscriptionDetails, data: obj });
            }
        }
    }
    , onEmployeeSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineOtherRequestFormA } = state().form;

        if (value === '') {
            dispatch(actions.change('wirelineOtherRequestFormA.employeeEmail', ''));
            dispatch(actions.change('wirelineOtherRequestFormA.wireLineApproverId', 0));
        } else {
            var obj = objects.find(o => o[propsName] === value);
            if (obj != null && obj.EmployeeId != wirelineOtherRequestFormA.employeeId) {
                dispatch(actions.change('wirelineOtherRequestFormA.employeeEmail', value));
                dispatch(actions.change('wirelineOtherRequestFormA.wireLineApproverId', obj.EmployeeId));
            }
        }
    }
    , onChangeExpedite: (model, value) => (dispatch) => {

        dispatch(actions.change(model, value));

        if (!trueFalseToBoolean(value)) {
            dispatch(actions.change('wirelineOtherRequestFormA.businessJustification', ''));
        }
    }
    , submitRequest: (date) => async (dispatch, state) => {

        const { wirelineOtherRequestFormA } = state().form;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;

        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
        }

        var data = {
            ...userData
            , requestTypeId: requestTypeId
            , wirelineOtherRequest: {
                ...wirelineOtherRequestFormA
                , requestInBehalfId: userData.requestInBehalfId
            }
        }

        dispatch({ type: setFormSubmitted, data: true });
        var res = await httpPost('external/wirelineOrderRequest', data);

        if (!(res || res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;
    }
    , fetchOtherOptions: () => (dispatch) => {
        fetchOtherRequestWirelineTypes(dispatch);
    }
    , resetWirelineOtherRequestForm: () => (dispatch) => {
        resetForm(dispatch);
    }
}

function resetForm(dispatch) {

    dispatch(actions.reset('wirelineOtherRequestFormA'));
    dispatch({ type: setFormSubmitted, data: false });
    //dispatch({ type: resetWirelineChangeVendorForm, vendor: defaultState.vendorDetails });
}

async function fetchOtherRequestWirelineTypes(dispatch, defaultDisplay = true) {

    var res = await httpGet('external/otherRequest/getOtherRequestWirelineTypes/'
        + defaultDisplay + '/');

    dispatch({ type: setOtherRequestOptions, data: res });

}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setOtherRequestOptions:
            return {
                ...state
                , otherOptions: action.data
            };
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };

        default: return state;
    }
}